import { UserStore } from 'AppClient/stores/UserStore';
import { CCStore } from 'AppClient/stores/CCStore';
import { BookingCCStore } from 'AppClient/stores/BookingCCStore';
import { BookingDictionariesStore } from 'AppClient/stores/BookingDictionariesStore';
import { NewBookingsStore } from 'AppClient/stores/NewBookingsStore';
import { AddressesStore } from 'AppClient/stores/AddressesStore';
import { UpcomingBookingsStore } from 'AppClient/stores/UpcomingBookingsStore';
import { PastBookingsStore } from 'AppClient/stores/PastBookingsStore';
import { AlertStore } from 'AppClient/stores/AlertStore';
import { HistoryStore } from 'AppClient/stores/HistoryStore';
import { PassengerDetailsStore } from 'AppClient/stores/PassengerDetailsStore';

import { User } from 'oidc-client';

export class RootStore {
	public userStore: UserStore;
	public ccStore: CCStore;
	public bookingCCStore: BookingCCStore;
	public bookingDictionariesStore: BookingDictionariesStore;
	public newBookingsStore: NewBookingsStore;
	public addressesStore: AddressesStore;
	public upcomingBookingsStore: UpcomingBookingsStore;
	public pastBookingsStore: PastBookingsStore;
	public alertStore: AlertStore;
	public historyStore: HistoryStore;
	public passengerDetailsStore: PassengerDetailsStore;

	constructor(user: User) {
		this.alertStore = new AlertStore();
		this.userStore = new UserStore(this, user);
		this.ccStore = new CCStore(this);
		this.bookingCCStore = new BookingCCStore(this);
		this.bookingDictionariesStore = new BookingDictionariesStore(this);
		this.newBookingsStore = new NewBookingsStore(this);
		this.passengerDetailsStore = new PassengerDetailsStore(this);
		this.addressesStore = new AddressesStore(this);
		this.upcomingBookingsStore = new UpcomingBookingsStore(this);
		this.pastBookingsStore = new PastBookingsStore(this);
		this.historyStore = new HistoryStore();
	}
}

export {
	UserStore,
	CCStore,
	BookingCCStore,
	BookingDictionariesStore,
	NewBookingsStore,
	AddressesStore,
	UpcomingBookingsStore,
	PastBookingsStore,
	AlertStore,
	HistoryStore,
	PassengerDetailsStore,
};
